// 大屏图表主题色板（单一来源，统一各页面图表配色）
// 状态色与 src/styles/_viewport.scss 保持一致

export const CHART = {
  // 柱状图统一渐变（青 → 深蓝）
  // 用法：new echarts.graphic.LinearGradient(0, 0, 0, 1, CHART.barGradient)
  barGradient: [
    { offset: 0, color: '#00E5FF' },
    { offset: 1, color: '#0E5F8A' },
  ],
  // 折线主系列（金色）
  line: '#FFB300',
  // 折线次系列（青色，用于对比系列）
  lineSecondary: '#00E3E3',
  // 饼图 / 多分类色板（青色系明度渐变，去彩虹色，保持全局统一）
  palette: [
    '#7FF3FF',
    '#00D4FF',
    '#00A8E8',
    '#0085D6',
    '#0057C2',
    '#0E3E7A',
    '#2EC7D8',
    '#1A78C2',
  ],
  // 地图点位
  mapPoint: '#FFD34D',
  mapPointBorder: '#FFF8B5',
}

// 根据数值计算地图标点大小（面积与数量成正比，sqrt 映射避免大数主导）
// value: 数据项 value 数组；valueIndex: 数量在数组中的下标；max: 最大数量
export function mapPointSize(value, valueIndex, max, minSize = 8, maxSize = 28) {
  const count = Number(value && value[valueIndex]) || 0;
  if (count <= 0 || !max) return 0;
  const ratio = Math.sqrt(count / max);
  return minSize + (maxSize - minSize) * ratio;
}
